import cx from 'classnames'
import { ApiStorage } from '@/utils/storage/ApiStorage'
import { TABS, TabKey } from './tabs'
import styles from './SideNav.module.css'

const BOT_TRACE_VIEWER_URL = 'http://10.81.11.67:7791/'

const PROD_HOSTNAME = 'moms.musinsalogistics.co.kr'

/**
 * 사이드바 상단 환경 배지(PR 리뷰). 예전에는 `MOMS · PROD` 가 하드코딩돼 있어 dev·dev-2·dev-3
 * 에서도 PROD 로 보였다 — 같은 화면의 API 선택기(`SelectBoxApi`)는 실제 대상 환경을 바꾸므로
 * 두 표시가 어긋나 온콜 담당자가 조치 환경을 오인할 수 있었다.
 *
 * 판정 순서가 중요하다: 호스트네임이 프로덕션이면 그것으로 끝낸다. `ApiStorage.apiType` 은
 * 프로덕션에서 쓰이지 않는 값이라 폴백으로 `'DEV'` 를 돌려주는데(ApiStorage.ts), 그 값을 먼저
 * 보면 운영에서 `MOMS · DEV` 가 찍힌다.
 */
export const resolveEnvLabel = (hostname: string, apiType: string): string => (hostname === PROD_HOSTNAME ? 'MOMS · PROD' : `MOMS · ${apiType}`)

/**
 * 시안 `aside.side` / `.brand` / `.subnav` / `.snb` 이식.
 * 맨 아래 외부 링크(핸드오프 §4.10): 뷰어는 HTTP + CORS 헤더가 없어 HTTPS 콘솔에서
 * fetch 도 iframe 도 브라우저가 막는다(mixed content). 링크 이동은 막히지 않으므로 새 탭으로 연다.
 */
export type SideNavProps = {
  tab: TabKey
  activeSection: string | null
  onJump: (id: string) => void
}

export const SideNav = ({ tab, activeSection, onJump }: SideNavProps): JSX.Element => {
  const tabDef = TABS.find((t) => t.key === tab) ?? TABS[0]

  return (
    <aside className={styles.side}>
      <div className={styles.brand}>
        온콜 콘솔
        <span>{resolveEnvLabel(window.location.hostname, ApiStorage.apiType.get())}</span>
      </div>

      <nav className={styles.subnav}>
        {tabDef.sections.map((sec) => (
          <button key={sec.id} type="button" className={cx(styles.snb, activeSection === sec.id && styles.on)} onClick={() => onJump(sec.id)}>
            {sec.label}
          </button>
        ))}
      </nav>

      <div className={styles.bottom}>
        <a className={styles.botLink} href={BOT_TRACE_VIEWER_URL} target="_blank" rel="noreferrer">
          봇 트레이스 뷰어 ↗
        </a>
        <span className={styles.caption}>사내망 · HTTP</span>
      </div>
    </aside>
  )
}
